import { Button, Box } from "@mui/material";
import ClientList from "./ClientList";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../../common/ErrorFallback";
import { Link } from "react-router";
import paths from "../../../routes";

const style = {
  pageContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
  },
} as const;

function ClientListContainer() {
  return (
    <Box data-testid="client-list-container" sx={style.pageContainer}>
      <Box sx={{ alignSelf: "end" }}>
        <Button
          data-testid="add-client-button"
          sx={{ alignSelf: "end" }}
          variant="contained"
          component={Link}
          to={paths.clients.new.pattern}
        >
          Add Client
        </Button>
      </Box>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <ClientList />
      </ErrorBoundary>
    </Box>
  );
}

export default ClientListContainer;
